<!-- 项目子项 -->
<template>
  <container-item-wrapper :widget="widget">
    <el-form-item v-if="!isPreviewState" ref="formItem" :rules="rules" :prop="tableFieldName" label-width="0px">
      <tableRender
        ref="tableRender"
        :style="{ height: formatterWidthOrHeightStyle(widget.options.tableHeight, true) || '600px', width: formatterWidthOrHeightStyle(widget.options.tableWidth) || '100%' }"
        :previewMode="isPreviewState"
        :relateId="widget.options.relateId"
        :rawRelateId="rawRelateId"
        :notNeedQueryTableData="widget.options.renderMode === 0"
        :externalParams="externalParams"
      ></tableRender>
    </el-form-item>
    <preview-table v-else :widget="widget" :isPreviewState="true"> </preview-table>
  </container-item-wrapper>
</template>

<script>
import { VFormSDK } from "@/CommonDP/lib/vform/VFormDesigner.umd.min.js";
import tableRender from "@/CommonDP/pages/commonRender/components/tableRender.vue";
import previewTable from "./preview.vue";

const { i18n, ContainerItemWrapper, emitter, refMixinDesign, refMixin } = VFormSDK;

export default {
  name: "JyhtTableItem",
  componentName: "FieldWidget",
  components: {
    ContainerItemWrapper,
    tableRender,
    previewTable
  },
  mixins: [emitter, i18n, refMixinDesign, refMixin],
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object
  },

  inject: {
    refList: {
      default: () => {
        console.warn("inject缺失refList!");
      }
    },
    globalOptionData: {
      default: () => {
        console.warn("inject缺失refList!");
      }
    },
    globalModel: {
      default: () => {
        console.warn("inject缺失globalModel!");
      }
    },
    getSlaveTableList: {
      default: () => () => {
        console.warn("inject缺失getSlaveTableList!");
      }
    },
    getRawFormData: {
      default: () => () => {
        console.warn("inject缺失getRawFormData!");
      }
    },
    getFlowDetail: {
      default: () => {
        console.warn("inject缺失getFlowDetail！");
        return () => {};
      }
    }
  },
  data() {
    return {
      rawRelateId: "",
      wrapHeight: {
        height: ""
      },
      externalParams: {},
      isFlowUse: false,
      isTableUse: false,
      primaryKeyValue: "",
      dlgFormConfig: {},
      rules: []
    };
  },
  computed: {
    isRuntime() {
      return !this.designState && !this.getFormRef()?.previewState;
    },
    tableFieldName() {
      return this.widget.options.name;
    },
    customClass() {
      return this.widget.options.customClass || "";
    },
    isPreviewState() {
      return this.getFormRef()?.previewState;
    },
    tableData() {
      return this.globalModel.formModel[this.tableFieldName];
    }
  },

  provide() {
    return {
      // 提供tablerender使用
      getWidget: () => this.widget,
      // 提供tablerender使用
      getPrimaryKeyValue: () => {
        return this.primaryKeyValue;
      },
      // 提供tablerender使用
      getDlgConfig: () => {
        return this.dlgFormConfig;
      }
    };
  },

  watch: {
    tableData() {
      this.$refs.formItem.validate("change");
    }
  },

  created() {
    // 这里只需要随便有个值，触发tablerender的watch，用以table渲染的初始化
    this.rawRelateId = "8888";
    if (this.isPreviewState) return;
    this.isFlowUse = !!this.refList.v_form_ref.$attrs.uuid;
    this.isTableUse = this.refList.v_form_ref.$attrs.callingFrom === "dynatic-table";

    const target = this.getSlaveTableList().find(({ slaveTableField }) => this.tableFieldName === slaveTableField) || {};
    const { relatedSlaveTableField, relatedMainField } = target;

    if (this.isTableUse) {
      this.primaryKeyValue = this.getRawFormData()[relatedMainField] || "";
      this.dlgFormConfig = this.refList.v_form_ref.$attrs.dlgFormConfig;
    } else if (this.isFlowUse) {
      const flowdetail = this.getFlowDetail().detail || {};
      this.primaryKeyValue = flowdetail.businessId || "";
      const flowType = flowdetail.flowType;
      this.dlgFormConfig = {
        // 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
        btnType: flowType === 1 ? "add" : flowType === 3 ? "check" : "edit",
        formId: this.refList.v_form_ref.$attrs.formId
      };
    } else {
      console.warn("当前直接调用表格的既不是流程也不是列表!尝试使用getRawFormData方法获取主键值");
      this.primaryKeyValue = this.getRawFormData()[relatedMainField] || "";
    }
    // 给参数筛选出关联主键的数据
    this.$set(this.externalParams, relatedSlaveTableField, this.primaryKeyValue);
    console.log(this.globalModel.formModel[this.tableFieldName], "created");
  },
  mounted() {
    this.buildFieldRules();
    // expose_setTableData执行要在tableitem的init之后
    setTimeout(() => {
      if (!this.isPreviewState && this.widget.options.renderMode === 0) {
        const tableData = this.globalModel.formModel[this.tableFieldName];
        if (tableData?.length) {
          this.$nextTick(() => {
            this.$refs.tableRender.expose_setTableData(tableData);
          });
        } else {
          this.$on("setFormData", (newFormData) => {
            const tableData = newFormData[this.tableFieldName];
            if (this.$refs.tableRender) {
              this.$refs.tableRender.expose_setTableData(tableData);
            } else {
              this.$nextTick(() => {
                this.$refs.tableRender.expose_setTableData(tableData);
              });
            }
          });
        }
      }
    }, 300);
  },

  methods: {
    buildFieldRules() {
      const { onValidate, required } = this.widget.options;
      if (required) {
        if (onValidate) {
          const tmpFunc = new Function(`return function onValidate(rule, value, callback) { ${onValidate}}`)();
          const customFn = tmpFunc.bind(this);
          this.rules.push({
            required: true,
            validator: customFn,
            trigger: ["change"]
          });
        } else {
          this.rules.push({
            required: true,
            validator: this.validatePass,
            trigger: ["change"]
          });
        }
      }
    },
    validatePass(rule, value, callback) {
      if (this.tableData?.length) {
        callback();
      } else {
        callback(new Error(this.widget.options.requiredHint));
      }
    },
    disableSubForm() {
      this.widget.options.disabled = true;
    },
    formatterWidthOrHeightStyle(length, isHeight) {
      if (typeof length === "string") length = length.trim();
      if (/^\d+$/.test(length)) {
        return `${length}px`;
      } else if (/^\d+px?$/.test(length)) {
        return length;
      } else if (/^\d+%?$/.test(length)) {
        if (isHeight) {
          return length.replace("%", "vh");
        } else {
          return length;
        }
      } else {
        console.warn("输入的高度或者宽度格式不正确！");
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.width-full {
  display: block;
}
.readonly-mode {
  width: 100%;
  display: inline-block;
  white-space: pre-wrap;
  line-height: 1.5;
  color: #c0c4cc;
}
div.table-container {
  padding: 5px;
  // border: 1px dashed #336699;
  box-sizing: border-box;
}
.table-container.selected {
  outline: 2px solid #409eff !important;
}
</style>
